import { WorkbookColumnBuilders } from '../../@types';
import { ParcelRateFormData } from '../../../../shared-jarvis';

/**
 * Column builders for Parcel Rate Request.
 *
 * Forked from BatchRateForm/workbookColumnBuilders.ts — shrinks from 12 entries to the
 * remaining config + bookkeeping columns. No Systems To Rate/MG P44 Account#/Contract Names
 * Filter (deprecated LTL concepts), no Targeted Carriers or the 3 contract-rate checkboxes
 * (no analog in the new ParcelQuoteOptions contract).
 *
 * CRITICAL: Column order/names MUST match ParcelShipmentDataToRate.cs exactly!
 * Order defined in: BS.RateQuality.Functions/ParcelRate/Entities/ParcelShipmentDataToRate.cs
 *
 * The order is:
 * 1. BG Rating Account#
 * 2. Notify Email Address
 * 3. Return Customer Rates
 * 4. Rate UPS
 * 5. Rate FedEx
 * 6-31. [Shipment data: PRG through Non-Standard Packaging (Y/N) - from uploaded file]
 * 32-36. Output columns: Error, API Response(ms), FilePart, Request, Response
 */
export const parcelRequestColumnBuilders: Array<{
  columnName: string;
  builder: (formFields: ParcelRateFormData) => any;
}> = [
  // 1. BG Rating Account#
  {
    columnName: 'BG Rating Account#',
    builder: (formFields) =>
      (formFields.accounts ?? [])
        .map((account) => account?.accountNumber)
        .filter(Boolean)
        .join(','),
  },

  // 2. Notify Email Address
  {
    columnName: 'Notify Email Address',
    builder: (formFields) =>
      formFields.notifyEmails.map((v: { value: string }) => v.value).join(','),
  },

  // 3. Return Customer Rates
  {
    columnName: 'Return Customer Rates',
    builder: (formFields) => (formFields.returnCustomerRates ? '1' : '0'),
  },

  // 4. Rate UPS
  {
    columnName: 'Rate UPS',
    builder: (formFields) => (formFields.rateUps ? '1' : '0'),
  },

  // 5. Rate FedEx
  {
    columnName: 'Rate FedEx',
    builder: (formFields) => (formFields.rateFedEx ? '1' : '0'),
  },

  // 6-26. Shipment data columns (PRG through Declared Value) will be inserted here by Excel worker

  // 25. Error
  {
    columnName: 'Error',
    builder: () => '',
  },

  // 26. API Response(ms)
  {
    columnName: 'API Response(ms)',
    builder: () => 0,
  },

  // 27. FilePart
  {
    columnName: 'FilePart',
    builder: () => 1,
  },

  // 28. Request
  {
    columnName: 'Request',
    builder: () => '',
  },

  // 29. Response
  {
    columnName: 'Response',
    builder: () => '',
  },
];
